// Environment variable utility
// SECURITY: No API keys should be accessed from frontend
// All AI calls route through the secure Magnus-Core backend
// ============================================================

/**
 * Get environment variable with fallback
 * Works with both Vite (import.meta.env) and standard process.env
 */
export const getEnv = (key: string): string | undefined => {
    // Vite environment variables
    try {
        if (import.meta?.env) {
            const value = import.meta.env[key];
            if (value && typeof value === 'string') return value;
        }
    } catch {
        // Not in Vite environment
    }

    // Node.js environment (for SSR or testing)
    if (typeof process !== 'undefined' && process.env) {
        const value = process.env[key];
        if (value) return value;
    }

    return undefined;
};

/**
 * Get required environment variable (throws if missing)
 */
export const getRequiredEnv = (key: string): string => {
    const value = getEnv(key);
    if (!value) {
        throw new Error(`Required environment variable ${key} is not set`);
    }
    return value;
};

/**
 * Check if running in development mode
 */
export const isDev = (): boolean => {
    return import.meta?.env?.DEV === true || getEnv('NODE_ENV') === 'development';
};

/**
 * Check if running in production mode
 */
export const isProd = (): boolean => {
    return import.meta?.env?.PROD === true || getEnv('NODE_ENV') === 'production';
};

export default { getEnv, getRequiredEnv, isDev, isProd };
